<div class="Txt-Withdraw-Banks">
  <h2>{{ 'Withdraw_Banks' | t }}</h2>
  <span>{{ 'desc_withdraw_banks' | t }}</span>

  <div style="margin-top: 20px">
    <h2>{{ 'Balance' | t }} {{ this._UserHelper.customerUser?.Balance }}</h2>
  </div>

  <div class="withdraw-auto-container">
    <form [formGroup]="banksDatas" style="margin-top: 20px">
      <!--    <mat-form-field style="width:100%">-->
      <!--      <mat-select placeholder="{{'Bank' | t}}" formControlName="bankList" required>-->
      <!--        <mat-option *ngFor="let x of bankList" [value]="x.BankId">-->
      <!--          {{x.Bank}}-->
      <!--        </mat-option>-->
      <!--      </mat-select>-->
      <!--    </mat-form-field>-->

      <mat-form-field class="example-full-width">
        <mat-label>{{ 'Bank' | t }}</mat-label>
        <input type="text" placeholder="Pick one" aria-label="Number" matInput formControlName="bankList" [matAutocomplete]="auto" />
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let x of bankList" [value]="x.Bank">
            {{ x.Bank }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <input matInput required placeholder="{{ 'Account_No' | t }}" formControlName="accountNo" />
      </mat-form-field>

      <mat-form-field style="width: 100%">
        <input matInput required placeholder="{{ 'Name_Surname' | t }}" formControlName="nameSurname" />
      </mat-form-field>

      <!--<mat-form-field style="width:100%">
        <input matInput required placeholder="{{ 'ssn' | t}}" formControlName="ssn">
      </mat-form-field>-->

      <!--    <mat-form-field style="width:100%">-->
      <!--      <input matInput required placeholder="{{ 'Amount' | t}}" type="number" formControlName="banksAmount">-->
      <!--    </mat-form-field>-->

      <div class="withdraw-automatic-row">
        <div class="box-first">
          <mat-form-field style="width: 150px; height: 70px" appearance="outline">
            <input matInput required placeholder="{{ 'Amount' | t }}" type="number" formControlName="banksAmount" />
          </mat-form-field>
        </div>

        <div class="box-second">
          {{ this._UserHelper.customerUser?.Symbol }}
        </div>

        <div class="box-third">
          {{ 'Automatic_Payout_Info' | t }}
        </div>
      </div>
      <div class="withdrawAutoIsChangeWarning" *ngIf="IsChangeActive == false">
        <p>{{ 'Automatic_Payout_Current_limit' | t }} : {{ CurrentLimit }} {{ this._UserHelper.customerUser?.Symbol }}</p>
        <p>{{ 'Automatic_Payout_Info' | t }}</p>
      </div>
    </form>

    <button mat-raised-button class="form-submit-button" (click)="submitBanksData()" [disabled]="!banksDatas.valid || IsChangeActive == false">{{ 'submit' | t }}</button>
  </div>
</div>
